import React from 'react'
import { Box, IconButton, Stack } from '@mui/material'
import { Facebook, Instagram, YouTube, LinkedIn } from '@mui/icons-material'
import { Link } from 'react-router-dom'
import Region from '../Region'
import { GVIconG } from 'src/constants'
import FooterSocialNav from './data/FooterSocialNav.json'
import { FaTiktok } from 'react-icons/fa'
import { asIcon } from 'src/utils/icons'

const IconFaTiktok = asIcon(FaTiktok)

const iconMap: Record<string, React.ElementType> = {
  YouTube,
  Facebook,
  Instagram,
  LinkedIn,
  TikTok: IconFaTiktok
}

export default function FooterSocial() {
  return (
    <Stack
      sx={{
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        gap: 3,
        pb: 4
      }}
    >
      <Stack data-gtm-click-subsection1='Footer Icon' sx={{ flexDirection: 'row', gap: 1 }}>
        <IconButton data-gtm-click-subsection2='Gemvision Icon' component={Link} to='/'>
          <Box component='img' sx={{ content: `url(${GVIconG})`, width: 24 }} alt='Gemvision - A Stuller Company' />
        </IconButton>
        <Region />
      </Stack>

      <Stack sx={{ flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', gap: 1 }}>
        {FooterSocialNav.map((subnav, index) => {
          const IconComponent = iconMap[subnav.icon]
          return (
            <Box key={index} data-gtm-click-subsection1='Footer Icon'>
              <IconButton
                data-gtm-click-subsection2={`${subnav.icon} Icon`}
                size='small'
                disableRipple
                href={subnav.url}
                target='_blank'
                rel='noopener noreferrer'
              >
                <IconComponent />
              </IconButton>
            </Box>
          )
        })}
      </Stack>
    </Stack>
  )
}
